export const iconFontAwesomeUsersPeoplePersonShelter = (
	<i className="fa-solid fa-person-shelter"></i>
);
